import i18n from "../i18n";

const VALID_KEYS = ["sendTime", "allowClientOverride"];

const CoachDailyMonitoring = (app) => {
  app
    .post(
      "/coach-daily-monitoring/save",
      async ({ api, assert, req, res, flash }) => {
        const { workflow: id, changes } = req.body;
        assert(
          id,
          400,
          i18n.t(
            "coaching-portal:coachDailyMonitoringActions.workflowIdRequired"
          )
        );
        const entries = Object.entries(changes || {}).filter(([key]) =>
          VALID_KEYS.includes(key)
        );
        assert(
          entries.length > 0,
          400,
          i18n.t("coaching-portal:coachDailyMonitoringActions.keyRequired")
        );

        try {
          // Save all fields from the form together, not one PUT per field —
          // the workflow-option endpoint only accepts one key at a time.
          for (const [key, value] of entries) {
            await api("workflow-option", {
              method: "PUT",
              body: { id, option: "morningBrief", key, value },
            });
          }
          flash(
            "success",
            i18n.t(
              "coaching-portal:coachDailyMonitoringActions.successfullySaved"
            )
          );
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    // `status` (draft/published) is Morning Brief's own on/off switch — kept
    // separate from the batched field save above and wired through the same
    // publish/unpublish shape `getting-started` options already use, not a
    // redundant `enabled` boolean living alongside `status`.
    .get(
      "/coach-daily-monitoring/publish/:id",
      async ({ api, assert, res, req, flash }) => {
        const { id } = req.params;
        assert(
          id,
          400,
          i18n.t(
            "coaching-portal:coachDailyMonitoringActions.workflowIdRequired"
          )
        );

        try {
          await api("workflow-option", {
            method: "PUT",
            body: {
              id,
              option: "morningBrief",
              key: "status",
              value: "published",
            },
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:customWorkflowsActions.successfullyPublished"
            )
          );
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .get(
      "/coach-daily-monitoring/unpublish/:id",
      async ({ api, assert, res, req, flash }) => {
        const { id } = req.params;
        assert(
          id,
          400,
          i18n.t(
            "coaching-portal:coachDailyMonitoringActions.workflowIdRequired"
          )
        );

        try {
          await api("workflow-option", {
            method: "PUT",
            body: { id, option: "morningBrief", key: "status", value: "draft" },
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:customWorkflowsActions.successfullyUnpublished"
            )
          );
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    );
};

export default CoachDailyMonitoring;
